import Validators from '../validators'

export default (store) => store.createEmbededEntityState({
  lastSave: 'youtubeinfo',
  timeRestriction: 'youtubeinfo',
  attrs: [
    'film_platform_id', 'channel_id', 'video_type', 'title',
    'language', 'note', 'private',
    'publish_date', 'cancel_date',
    'region_restrictions_allowed', 'region_restrictions_blocked'
  ],
  titles: [
    store.__('Video ID'), store.__('YouTube channel'),
    store.__('video type'), store.__('title'), store.__('language'),
    store.__('note'), store.__('private'),
    store.__('published'), store.__('canceled'),
    store.__('allowed'), store.__('blocked')
  ],
  _sortField: 'title',
  validators: {
    film_platform_id: Validators.isMandatory(store),
    channel_id: Validators.isMandatory(store),
    video_type: Validators.isMandatory(store),
    title: Validators.isMandatory(store),
    publish_date: Validators.isMandatoryDate(store),
    cancel_date: Validators.isDate(store),
    region_restrictions_allowed: [
      Validators.isValidNegativeRegion(store),
      Validators.regionTest(store)],
    region_restrictions_blocked: [
      Validators.isValidNegativeRegion(store),
      Validators.regionTest(store)]
  }
})
